import generic_backend_request_post from 'functions/server/generic_backend_request_post';
import ScenarioRequest from 'open-api-gen/model/ScenarioRequest.js';

async function get_saved_scenario(scenarioId, scenarioName) {
    /**
     * This function sends a POST request to the backend server to get a saved scenario by its ID.
     * It takes in the scenarioId and scenarioName and returns the response from the server.
     * 
     * @param {string} scenarioId - The ID of the scenario to get.
     * @param {string} scenarioName - The name of the scenario to get.
     * @return {Object} - The response from the server.
     */
    if (!scenarioId && !scenarioName) {
        throw new Error('Either scenarioId or scenarioName must be provided for get_saved_scenario');
    }
    
    const requestJson = {
        "scenarioId": scenarioId,
        "scenarioName": scenarioName
    }
    const scenarioRequest = ScenarioRequest.constructFromObject(requestJson);

    const retJson = await generic_backend_request_post(scenarioRequest, '/saved_scenario');

    return retJson;
}

export default get_saved_scenario